import React, { useState, useRef, useEffect } from 'react';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import css from './VideoThumbnail.module.css';

const VideoThumbnail = ({ videoSrc }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    //Youtube video thumbnail extraction
    if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
      const extractYouTubeId = (url) => {
        const regExp =
          /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regExp);
        return match ? match[1] : null;
      };
      const videoId = extractYouTubeId(videoSrc);
      if (videoId) {
        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        setThumbnail(thumbnailUrl);
      }
    } else {
      // Firebase video thumbnail extraction
      const videoElement = videoRef.current;

      // Set time to extract thumbnail (e.g., 5 seconds)
      videoElement.currentTime = 5;

      videoElement.onloadeddata = () => {
        // Once the video frame is loaded, draw it on the canvas
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        // Convert the canvas to a base64 image and store it in state
        const imageUrl = canvas.toDataURL('image/png');
        setThumbnail(imageUrl);
      };
    }
  }, [videoSrc]);

  return (
    <div className={css.thumbWrapper}>
      <video crossOrigin="anonymous" ref={videoRef} src={videoSrc} style={{ display: 'none' }} />
      <canvas ref={canvasRef} width="300" height="200" style={{ display: 'none' }} />
      <PlayCircleOutlineIcon className={css.playIcon} />
      {thumbnail ? (
        <img className={css.thumb} src={thumbnail} alt="Video Thumbnail" />
      ) : (
        <img className={css.thumbPlaceholder}></img>
      )}
    </div>
  );
};

export default VideoThumbnail;
